import type { TabRegistryEntry } from "@/types/tabs";
import { LayoutDashboard, AlertTriangle, CreditCard, HeadphonesIcon, UsersRound, Building2 } from "lucide-react";

import PlatformAdminDashboard from "@/pages/platform/PlatformAdminDashboard";
import PlatformIncidents from "@/pages/platform/PlatformIncidents";
import PlatformBilling from "@/pages/platform/PlatformBilling";
import PlatformSupport from "@/pages/platform/PlatformSupport";
import PlatformTeam from "@/pages/platform/PlatformTeam";
import TenantDetail from "@/pages/platform/TenantDetail";

export const platformTabRegistry: TabRegistryEntry[] = [
  { routePattern: "/platform", component: PlatformAdminDashboard, label: "Dashboard", icon: LayoutDashboard, closable: false, singleton: true },
  { routePattern: "/platform/incidents", component: PlatformIncidents, label: "Incidents", icon: AlertTriangle, closable: true, singleton: true },
  { routePattern: "/platform/billing", component: PlatformBilling, label: "Billing", icon: CreditCard, closable: true, singleton: true },
  { routePattern: "/platform/support", component: PlatformSupport, label: "Support", icon: HeadphonesIcon, closable: true, singleton: true },
  { routePattern: "/platform/team", component: PlatformTeam, label: "Team", icon: UsersRound, closable: true, singleton: true },
  { routePattern: "/platform/:companyId", component: TenantDetail, label: (p) => `Tenant ${p.companyId.slice(0, 8)}…`, icon: Building2, closable: true, singleton: false },
];
